import { Module } from 'vuex'

export interface ErrorStore {
  error: any
}
export const errorStore: Module<ErrorStore, {}> = {
  namespaced: true,
  state: () => ({
    error: null
  }),
  mutations: {
    addError(state, error: any) {
      state.error = error
    }
  },
  actions: {},
  getters: {
    error: state => state.error
  }
}
